export interface WorkspaceFilter {
  searchFor?: string;
  page?: number;
  pagesize?: number;
  order?: string;
  direction?: number;
}

export const defaultWorkspaceFilterState: WorkspaceFilter = {
  searchFor: '',
  page: 1,
  pagesize: 12,
  order: 'name',
  direction: 1
};
